import { Controller } from "@hotwired/stimulus"

// Добавление и удаление строк вложенной формы — контактов клиента.
//
// Шаблон новой строки лежит в <template>, индекс подставляется на месте: Rails
// различает вложенные записи по индексу в имени поля, и одинаковый индекс у двух
// строк привёл бы к тому, что вторая затирает первую.
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()

    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.nextIndex())
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  // Уже сохранённая строка не удаляется из DOM, а помечается _destroy: иначе
  // Rails просто не получит её в параметрах и ничего не удалит.
  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-nested-fields-row]")
    const flag = row.querySelector("input[name*='_destroy']")

    if (flag) {
      flag.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
  }

  nextIndex() {
    return new Date().getTime()
  }
}
